export async function uploadToR2(file, livechatUuid, channelName) {
  try {
    const presignedUrl = await handlePresignedUrl(file.name, livechatUuid, channelName);
    await fetch(presignedUrl, {
      method: 'PUT',
      body: file
    });

    const url = `${process.env.REACT_APP_LIVECHAT_BUCKET_DOMAIN}/uploads/conversation_attachment/livechat_uuid/${livechatUuid}/channel_name/${channelName}/${file.name}`;
    return url;
  } catch (error) {
    throw error;
  }
}

async function handlePresignedUrl(fileName, livechatUuid, channelName) {
  try {
    const result = await fetch(
      `${process.env.REACT_APP_LIVECHAT_GO_SERVICE}/presigned_url`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST'
        },
        body: JSON.stringify({
          file_name: fileName,
          livechat_uuid: livechatUuid,
          channel_name: channelName
        })
      }
    );
    const parsed = await result.json();

    return parsed.url;
  } catch (error) {
    throw error;
  }
}
